<div class="flex-col height100p">
    <sm-table2 *ngIf="table != null" class="flex-item-fill" [data]="table"(onRowSelect)="rowSelect($event)"></sm-table2>
    <p-tabView class="flex-item-fill height100p full-height">
        <p-tabPanel header="Expressions">
            <sm-table2 *ngIf="expressionsTable != null" [data]="expressionsTable"></sm-table2>
        </p-tabPanel>
        <p-tabPanel header="Quellcode">
            <textarea #textAreaSourceCode *ngIf="export != null" spellcheck="false" wrap="off" pInputTextarea class="source-code monospace no-resize" [ngModel]="export.source"></textarea>
        </p-tabPanel>
        <p-tabPanel header="Fehlermeldung">
            <textarea #textAreaSourceCode *ngIf="export != null" spellcheck="false" pInputTextarea class="source-code monospace no-resize" [ngModel]="export.errorMessage"></textarea>
        </p-tabPanel>
    </p-tabView>

</div>
